import { render, staticRenderFns } from "./enzymes.vue?vue&type=template&id=14fa0f04&"
import script from "./enzymes.vue?vue&type=script&lang=js&"
export * from "./enzymes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports